<template>
  <el-select size="mini" v-model="newValue"
    placeholder="请输入客户名称"
    filterable
    v-select-loadmore="loadmore"
    @click.native="remoteMethod('')"
    remote
    clearable
    :remote-method="remoteMethod">
    <el-option
      v-for="item in options"
      :key="item.customerId"
      :label="item.customerName"
      :value="item.customerId">
    </el-option>
  </el-select>
</template>

<script>
  import {Message} from "element-ui";
  export default {
    data() {
      return {
        newValue: '' ,
        options:[],
        selectSearch: { // 下拉懒加载分页
            page: 1,
            pageSize: 10
        },
      }
    },
    computed: {},
    watch: {
      newValue(newValue) {
        this.$emit('input', newValue);
      },
    },
    mounted() {
    },
    created() {
      this.getCustomerList(this.selectSearch);
    },
    methods: {
      // 获取客户一览
      getCustomerList(params) {
        let that = this;
        if(params.page === 1) this.options = [];
        this.getRequest("/dev/system/getCustomerList", params).then(resp => {
        if (resp.status == 200 && resp.data.code == 1000) {
          let options = resp.data.result.records;
          if(params.page <= resp.data.result.pages){
            options.forEach((item) => {
              that.options.push(item);
            })
          }
        } else {
          Message.info(resp.data.message);
        }
        })
      },
      // 相当于翻页查询
      loadmore(val) {
          this.selectSearch.page++;
          let params = {
            ...this.selectSearch,
            customerName: val
          }
          this.getCustomerList(params)
      },
      // 筛选
      remoteMethod(query) {
          this.options = [];
          this.selectSearch.page = 1;
          let params = {
              ...this.selectSearch,
              customerName: query
          }
          this.getCustomerList(params)
      },
    }
  }
</script>


